import { useSelector } from 'react-redux'

import { GlobalSpinner } from '@taxfix/scouts-ui'

import { getIsRequestPending } from '@/selectors/request'

export const RequestObserver = () => {
    const shouldDisplayGlobalSpinner = useSelector(getIsRequestPending)

    if (shouldDisplayGlobalSpinner) return <GlobalSpinner />

    return null
}
